export default class SuccessController {
  constructor($rootScope) {
    this.account = $rootScope.account;
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/success.js